import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../Components/internal-pages/Cta_Section";
import LeftImgrightContent from "../Components/internal-pages/Leftimg_rightContent";
import RightimgLeftContent from "../Components/internal-pages/Rightimg_leftContent";
import NogapRightImage from "../Components/internal-pages/No_gap_right_Img";
import ClinetsLogoSlider from "../Components/home/ClientsLogoSlider";
import Whychooseus from "../Components/internal-pages/WhyChooseus";

const CustomizedGifts =()=>{
    const CTAContent = [
        {
          pageName: "Customized Gifts",
          paragraphitalic: "Make Every Gift Truly Yours ",
          paragraphText:
            "At eYantra, we believe in the power of personalization. Customized gifts are a powerful way to connect, engage, and leave a lasting impression on your audience. Whether you're looking to showcase your company’s branding or offer a more personal touch, our customized gifting solutions bring your ideas to life in the most meaningful way.",
          ContactFormName: "Branded Merchandise",
        },
      ];
      const ContentImg = [
        {
          index: 0,
          leftImg: "./assests/images/banners/Customized Gifts with Company Branding.jpg",
          leftHeading: "Customized Gifts with Company Branding",
          leftSmallpara: "Branding That Speaks for Itself",
          leftParagraph:
            "Raise the stakes for your corporate identity with customized gifts that proudly showcase your company’s logo and message. Whether it's for client appreciation, employee recognition, or promotional giveaways, our branded gifts turn every gesture into a brand statement.",
          leftRedirectUrl: "/customized-gifts/customized-gifts-with-company-branding",
        },
      ];
    
      const rightImgContent = [
        {
          index: 0,
          rightImg: "./assests/images/banners/Customized Gifts without Company Branding.jpg",
          rightHeading: "Customized Gifts without Company Branding ",
          rightSmallpara: "Just A Personal Touch, Without A Logo",
          rightParagraph:
            "Sometimes, the most powerful gifts are those that speak directly to the heart. With personalized gifts that focus purely on their taste and style, we offer the opportunity to give something truly unique without the need for corporate branding.",
          rightRedirectUrl: "/customized-gifts/customized-gifts-without-company-branding",
        },
      ];
    
    return(
        <>
        <Helmet>
            <title>Corporate Gifts in Hyderabad by eYantra</title>
            <meta name="description" content="eYantra offers customized gifts, joining kits, and onboarding kits for employees. Get branded corporate gifts and welcome kits across Hyderabad."/>
            <meta name="keywords" content="eyantra, customized gifts, corporate gifting, joining kits, onboarding kits for employees, corporate gifts for employees, welcome kits,corporate gifts in hyderabad, branded corporate"/>
            
        </Helmet>

        <div className="p-0 m-2">
        <Ctapage data={CTAContent} />

        <LeftImgrightContent leftImgContent={ContentImg[0]} />
        <RightimgLeftContent data={rightImgContent[0]} />
        </div>
        <div className="my-5">
            <ClinetsLogoSlider/>
        </div>
        <Whychooseus/>
      


        </>
    )
}

export default CustomizedGifts;